import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, Menu, X, Shield, Sparkles } from "lucide-react";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [typesOpen, setTypesOpen] = useState(false);

  return (
    <header className="w-full bg-white border-b border-slate-200 sticky top-0 z-40">
      <div className="h-1 bg-[#0b1e3f]" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 min-w-0">
            <div className="w-9 h-9 shrink-0 rounded-full bg-[#16a3a8] flex items-center justify-center text-white">
              <Sparkles className="w-5 h-5" />
            </div>
            <div className="leading-tight min-w-0">
              <div className="text-[15px] sm:text-xl font-extrabold text-[#0b1e3f] tracking-tight truncate">
                topastrologer<span className="text-[#16a3a8]">inindia</span>.com
              </div>
            </div>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-8 text-sm font-semibold text-[#0b1e3f]">
            <Link to="/" className="hover:text-[#16a3a8] transition-colors">HOME</Link>
            <div
              className="relative"
              onMouseEnter={() => setTypesOpen(true)}
              onMouseLeave={() => setTypesOpen(false)}
            >
              <button className="flex items-center gap-1 hover:text-[#16a3a8] transition-colors">
                TYPES <ChevronDown className="w-4 h-4" />
              </button>
              {typesOpen && (
                <div className="absolute top-full left-0 mt-1 bg-white border border-slate-200 rounded-md shadow-lg min-w-[210px] py-2 z-50">
                  {[
                    "Vedic Astrology",
                    "KP Astrology",
                    "Nadi Astrology",
                    "Tarot Reading",
                    "Horoscope Matching",
                  ].map((t) => (
                    <a
                      key={t}
                      href="#astrologers"
                      className="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-[#16a3a8]"
                    >
                      {t}
                    </a>
                  ))}
                </div>
              )}
            </div>
            <a href="#reviews" className="hover:text-[#16a3a8] transition-colors">REVIEWS</a>
            <a href="#articles" className="hover:text-[#16a3a8] transition-colors">ARTICLES</a>
            <Link
              to="/admin/login"
              className="flex items-center gap-1 text-xs px-3 py-1.5 rounded border border-slate-300 text-slate-700 hover:bg-slate-50"
            >
              <Shield className="w-3.5 h-3.5" /> Admin
            </Link>
          </nav>

          <button
            className="md:hidden p-2 text-slate-700"
            onClick={() => setOpen(!open)}
            aria-label="Toggle Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {open && (
          <div className="md:hidden pb-4 border-t border-slate-200">
            <div className="flex flex-col gap-3 pt-3 text-sm font-semibold text-[#0b1e3f]">
              <Link to="/" onClick={() => setOpen(false)}>HOME</Link>
              <a href="#astrologers" onClick={() => setOpen(false)}>TYPES</a>
              <a href="#reviews" onClick={() => setOpen(false)}>REVIEWS</a>
              <a href="#articles" onClick={() => setOpen(false)}>ARTICLES</a>
              <Link to="/admin/login" onClick={() => setOpen(false)} className="text-slate-700">Admin Login</Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
